import { SmartTable, SmartTableColumn, SmartTableDataItem } from '@design/components/smart-table';
import clsx from 'clsx';
import React from 'react';

import styles from './SharedTable.module.scss';

export interface SharedTableProps<T> {
  tableData: SmartTableDataItem<T>[];
  tableColumns: SmartTableColumn<T>[];
  title?: string;
  titleSize?: 'small' | 'large';
  noCellPadding?: boolean;
}

export const SharedTable = <T extends {}>({
  tableData,
  tableColumns,
  title,
  titleSize = 'small',
  noCellPadding = false,
}: SharedTableProps<T>) => {
  const isSmallTitle = titleSize === 'small';
  const hasTitle = !!title;

  return (
    <div
      className={clsx(styles.root, {
        [styles.gapNone]: !hasTitle,
        [styles.gapSmallTitle]: hasTitle && isSmallTitle,
        [styles.gapLargeTitle]: hasTitle && !isSmallTitle,
      })}
    >
      {hasTitle && (
        <div className={isSmallTitle ? styles.titleSmall : styles.titleLarge}>
          {title}
        </div>
      )}
      <div
        className={clsx(styles.smartTableWrapper, {
          [styles.noCellPadding]: noCellPadding,
        })}
      >
        <SmartTable
          columns={tableColumns}
          data={tableData}
          withBodyRowHover={false}
        />
      </div>
    </div>
  );
};
